<template>
  <!-- width="600px" 或者  width="60%"   -->
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title="电梯二维码"
      :show-close="true"
      :visible="true"
      :before-close="handleBeforeClose"
      width="700px"
    >
      <div>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="300像素" name="three">
            <img :src="detail.three" alt="" />
          </el-tab-pane>
          <el-tab-pane label="500像素" name="five">
            <img :src="detail.five" alt="" />
          </el-tab-pane>
          <el-tab-pane label="700像素" name="seven">
            <img :src="detail.seven" alt="" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
        <el-button class="plr28" type="primary" size="mini" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import {
  getQrCode
} from "@/api/ElevatorManagement";


export default {
  data() {
    return {
      detail: {
        three: '',
        five: '',
        seven: ''
      },
      activeName: 'three'
    };
  },
  props: {
    editData: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.getQrCode()
  },
  methods: {
    async getQrCode() {
      const res = await getQrCode({liftId: this.editData.id})
      if (res.code === 200) {
        res.data.forEach((item) => {
          if (item.qrCodeType === 300) {
            this.detail.three = item.fileUrl
          }
          if (item.qrCodeType === 500) {
            this.detail.five = item.fileUrl
          }
          if (item.qrCodeType === 700) {
            this.detail.seven = item.fileUrl
          }
        })
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("cancel");
    },
    handleClick() {

    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ElevatorManagement/components/CheckCode.vue